import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { fromEvent, Observable, of, Subject } from 'rxjs';
import {
  delay,
  distinctUntilChanged,
  filter,
  switchMap,
  takeUntil,
  tap,
} from 'rxjs/operators';
import { MapService } from 'src/app/vehicles/services/map.service';
import { MapAsideService } from './service/map-aside.service';
import { VariantMapAside } from './models/variant-map-aside';

@Component({
  selector: 'app-map-aside',
  templateUrl: './map-aside.component.html',
  styleUrls: ['./map-aside.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapAsideComponent implements OnDestroy, OnInit {
  @Input() position: 'left' | 'right' = 'right';
  private readonly onDestroy$ = new Subject<boolean>();
  readonly hidden$: Observable<boolean>;
  readonly variant$: Observable<VariantMapAside>;
  // Esta propiedad la usamos solo para el estado interno
  private isCurrentlyHidden = true;
  readonly isMaximized$: Observable<boolean>;

  constructor(
    private cdr: ChangeDetectorRef,
    private mapService: MapService,
    private mapAsideService: MapAsideService
  ) {
    this.hidden$ = this.mapAsideService.isHidden$.pipe(
      takeUntil(this.onDestroy$),
      distinctUntilChanged(),
      tap((isHidden) => {
        this.isCurrentlyHidden = isHidden;
      }),
      switchMap((isHidden) => {
        this.cdr.markForCheck();
        return isHidden ? of(isHidden) : of(isHidden).pipe(delay(800));
      }),
      tap(() => {
        if (this.isCurrentlyHidden) {
          setTimeout(() => {
            this.mapService.map.invalidateSize({
              animate: true,
              duration: 0.3,
            });
          }, 800);
        } else {
          this.mapService.map.invalidateSize({
            animate: true,
            duration: 0.3,
          });
        }
      })
    );
    this.variant$ = this.mapAsideService.variant$.pipe(
      takeUntil(this.onDestroy$),
      distinctUntilChanged()
    );
    this.isMaximized$ = this.mapAsideService.isMaximized$.pipe(
      takeUntil(this.onDestroy$),
      distinctUntilChanged(),
      tap(() => {
        setTimeout(() => {
          this.mapService.map.invalidateSize({
            animate: true,
            duration: 0.3,
          });
        }, 300);
      })
    );
  }

  ngOnInit(): void {
  }

  closeMapAside() {
    this.mapAsideService.hide();
  }


  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
    console.log('SE EJECUTO ON DESTROY');
  }
}
